module.exports = __webpack_public_path__ + "img/one-line.50ffba4b.png";